<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("GenerateTestQuestions_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="field-search-rowtable-dataIntegration"
                      :label="'Question Set'"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-rowtable-dataIntegration"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              
              <div class="action-controls">
                <!-- Refresh Button -->
                <v-btn
                  id="button-refresh-validationgenerate"
                  color="grey-darken-1"
                  class="control-btn refresh-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  @click="ReFreshGet()"
                  icon
                >
                  <v-icon size="24">mdi-refresh</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Refresh
                  </v-tooltip>
                </v-btn>
                
                <!-- Divider -->
                <v-divider vertical thickness="1" length="50" class="mx-4"></v-divider>
                
                <!-- Add Button -->
                <v-btn
                  id="button-refresh-validationgenerate"
                  color="primary"
                  class="control-btn create-btn"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-plus-circle"
                  rounded="xl"
                  @click="Upload()"
                >
                  <span class="btn-text">{{ $t("add") }}</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <!-- <td style="text-align: center">{{ item.number }}</td> -->
              <td style="text-align: left">{{ item.number }}</td>
              <td style="text-align: left">{{ item.name }}</td>
              <td style="text-align: left">{{ item.result }}</td>
              <td style="text-align: left">{{ item.status }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">
                <v-btn
                  id="button-reprocess-validationgenerate"
                  color="orange-lighten-1"
                  variant="flat"
                  size="small"
                  @click="Reprocess(item)"
                  class="minimal-btn"
                  icon
                >
                  <v-icon size="22" color="white">mdi-file-sync</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Reprocess
                  </v-tooltip>
                </v-btn>
              </td>
              <td style="text-align: center">
                <div class="action-container">
                  <div class="action-group">
                    <!-- Edit -->
                    <v-btn
                      id="button-edit-validationgenerate"
                      variant="text"
                      density="comfortable"
                      class="action-btn edit-btn"
                      icon
                      @click="EditValidationGenerate(item)"
                    >
                      <v-icon size="18">mdi-pencil-outline</v-icon>
                    </v-btn>
                    
                    <!-- Download -->
                    <v-btn
                      id="button-download-validationgenerate"
                      variant="text"
                      density="comfortable"
                      class="action-btn download-btn"
                      icon
                      @click="Download(item.generateID)"
                      :disabled="item.status != 'success'"
                    >
                      <v-icon size="18">mdi-download-outline</v-icon>
                    </v-btn>
                    
                    <!-- Custom Divider -->
                    <div class="action-divider"></div>
                    
                    <!-- Delete -->
                    <v-btn
                      id="button-delete-validationgenerate"
                      variant="text"
                      density="comfortable"
                      class="action-btn delete-btn"
                      icon
                      @click="DeleteValidate(item.generateID)"
                      :disabled="item.status === 'Processing'"
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "ValidationGenerate",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    loadingTable: false,
    searchName: "",
    isFirst: true,
    checkbox1: false,
    dialog: false,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false },
        { title: "Question Set", align: "left", sortable: true, value: "Name" },
        {
          title: "Process",
          align: "left",
          sortable: true,
          value: "ImportedDataCount",
        },
        { title: "Status", align: "left", sortable: true, value: "Status" },
        {
          title: "Create by",
          align: "left",
          sortable: true,
          value: "CreateBy",
        },
        { title: "Reprocess", align: "left", sortable: false },
        { title: "Action", align: "center", sortable: false },
        // { title: 'Reprocess', align: 'left', sortable: false },
        // { title: 'Edit', align: 'left', sortable: false },
        // { title: 'Download', align: 'left', sortable: false },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.Get();
    },
    Upload() {
      let self = this;
      self.$router.push({
        name: "ValidationGenerateUpload",
      });
    },
    EditValidationGenerate(item) {
      let self = this;
      self.$router.push({
        name: "ValidationGenerateUpload",
        query: {
          id: item.generateID,
        },
      });
    },
    Get() {
      let self = this;
      if (self.searchName == null) {
        self.searchName = "";
      }
      // self.dialog = true;
      self.loadingTable = true;
      let { page, itemsPerPage } = self.options;
      self.sortBy =
        self.options.sortBy == undefined || self.options.sortBy.length == 0
          ? null
          : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc == undefined || self.options.sortDesc.length == 0
          ? null
          : self.options.sortDesc[0];
      let temp = {
        name: self.searchName,
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        sortDesc: self.sortDesc,
        sortBy: self.sortBy,
      };
      self.$call.GetTableValidationGenerate(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            if (self.sortDesc == null) {
              self.AutoRefresh();
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      let self = this;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
      };
      self.$call.GetTableValidationGenerate(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      let temp = csv.replaceAll("\r", "");
      let lines = temp.split("\n");
      if (lines[0] != "text_org,text_en") {
        // this.requestVector.entity = null;
        alert("Please Enter Correct Format!");
      } else {
        const formDataDoc = new FormData();
        formDataDoc.append("entity", files[0]);
        // this.requestVector.entity = formDataDoc;
      }
    },
    resourceResult(result) {
      if (result != "") {
        let arr = result.split("/");
        if (arr.length == 2) {
          return "0/" + arr[1];
        }
      }
      return result;
    },

    Reprocess(source) {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("vectorReprocess"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            self.loading = true;
            self.$call.ReprocessValidationGenerate(
              source.generateID,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  source.status = "Reprocess";
                  source.result = self.resourceResult(source.result);
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.AutoRefresh();
                }
                self.loading = false;
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                self.Adddialog = false;
                console.error(errorResource);
              }
            );
          }
        });
    },
    Download(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.$call.DownloadCSVQuestions(
        id,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            let fileName = `Questions_${self.convertDateToString(
              new Date(),
              ""
            )}.csv`;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteValidate(id) {
      let self = this;
      // self.$swal.fire({
      //   title:'Are you sure to delete this data?',//this.$t('vectorReprocess'),
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: this.$t('yes'),
      //   cancelButtonText: this.$t('cancel'),

      // })
      self.$swal
        .fire({
          title: this.$t("confirmDeletion"),
          text: this.$t("confirmDeletion2"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            self.loading = true;
            self.$call.DeleteValidationGenerate(
              id,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.Get();
                }
                self.loading = false;
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                self.Adddialog = false;
                console.error(errorResource);
              }
            );
          }
        });
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    checkForLoop(data) {
      for (let value of data) {
        let totalSp = value.result.split("/");
        let total = parseInt(totalSp[0]);
        let total2 = parseInt(totalSp[1]);
        if (
          total < total2 &&
          (value.status == "Reprocess" || value.status == "Processing")
        ) {
          return false;
        }
      }
      return true;
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;

      do {
        for (let value of self.dataTable) {
          let totalSp = value.result.split("/");
          let total = parseInt(totalSp[0]);
          let total2 = parseInt(totalSp[1]);
          if (
            total < total2 &&
            (value.status == "Reprocess" || value.status == "Processing")
          ) {
            self.ReFreshGet();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != "/ValidationGenerate") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 200px;
}
.refresh-btn {
  margin-left: 9px;
  opacity: 0.7;
}

.refresh-btn:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.06) !important;
}

.download-btn[disabled] {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.38) !important;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

/* action disable button delete */
.delete-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  background-color: rgba(244, 67, 54, 0.388) !important;
  pointer-events: none !important;
}

.delete-btn:disabled .v-icon {
  color: rgba(244, 67, 54, 0.5) !important;
}

.delete-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: rgba(244, 67, 54, 0.1) !important;
}
</style>
